// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ImageIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M6.36 14.05c.75.4 1.4.8 1.9 1.11.12.08.28.07.4-.03l3.06-2.75c1.93-1.7 4.7-1.82 6.77-.33l3.48 2.53c.22.16.53 0 .53-.26V7.6c0-3.65-2.35-6.1-5.84-6.1H7.33C3.84 1.5 1.5 3.96 1.5 7.6v6.44c0 .28.33.44.56.28 1.08-.72 2.53-1.23 4.3-.28"
        opacity=".5"
      />
      <path d="M7.86 5.03c1.41 0 2.56 1.15 2.56 2.56s-1.15 2.56-2.56 2.56S5.29 9 5.29 7.6s1.15-2.56 2.57-2.56m4.96 8.57c1.34-1.16 3.26-1.25 4.7-.21l4.78 3.52q.15.11.13.3c-.33 3.18-2.55 5.27-5.77 5.27H7.33q-1.7 0-2.98-.72c-.19-.1-.2-.37-.04-.51zM1.9 16.6c1.2-1.1 2.22-1.87 3.67-1.1l1.24.72c.19.11.21.37.05.52l-3.8 3.42c-.15.13-.37.1-.48-.05q-.85-1.25-1.02-3 0-.15.09-.25z" />
    </g>
  </SvgIcon>
);

export default ImageIcon;
